exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 480px) {\n.zd-widget-move-step1 #launcher {\n    bottom: 150px !important;\n}\n}\n@media (min-width: 480px) and (max-width: 767px) {\n.zd-widget-move-step1 #launcher {\n    bottom: 105px !important;\n}\n}\n@media (max-width: 991px) {\n.zd-widget-move-step3 #launcher {\n    bottom: 100px !important;\n}\n}\n@media (max-width: 767px) {\n.zd-widget-move-step5 #launcher {\n    bottom: 90px !important;\n}\n}\n@media (max-width: 767px) {\n.zd-widget-move-step5-holiday.zd-widget-move-step5 #launcher {\n    bottom: 165px !important;\n}\n}", ""]);

// exports
